import Form from '../components/Form';
import 'form-serializer';
import 'jquery-validation';
import VanillaModal from 'vanilla-modal';

class FormOffer extends Form {
  setupDefaults() {
    super.setupDefaults();

    this.endpoint = this.$el.attr('action');

    this.dom = {
      ...this.dom,
      $submitBtn: this.$el.find('input[type="submit"]'),
      $cta: document.querySelector('.optional-prod-details__cta')
    };

    if (this.$el.hasClass('js-open-modal')) {
      this.modal = new VanillaModal({
        onBeforeClose: () => {
          if (this.dom.$cta) window.location = this.dom.$cta.href;
        },
        clickOutside: true,
        'class': 'modal-open'
      });
    }
  }

  addListeners() {
    this.$el.on('submit', ::this.onOfferSubmit);
  }

  onOfferSubmit(e) {
    e.stopPropagation();
    e.preventDefault();

    if (this.$el.valid()) {
      this.submitOffer();
    }
  }

  async submitOffer() {
    this.dom.$submitBtn.attr('disabled', 'disabled').parent().addClass('is-loading');
    const res = await this.postOffer();

    if (res.success) {
      const data = this.$el.serializeJSON();
      window.dataLayer.push({
        event: 'formSubmit',
        formName: data.requestType,
        formId: data.MasterUniqueFormID
      });
      if (this.$el.hasClass('js-open-modal')) {
        this.onOpenModal()
      } else {
        const redirectURL = res.response.redirectUrl;
        window.location.replace(redirectURL);
      }
    } else {
      this.clearFormLevelError();
      this.displayFormLevelError(res.message);
      this.dom.$submitBtn.removeAttr('disabled').parent().removeClass('is-loading');
    }
  }

  postOffer() {
    const data = this.$el.serializeJSON();
    return $.ajax({
      method: 'POST',
      url: this.endpoint,
      contentType: 'application/json',
      data
    })
  }

  onOpenModal() {
    this.modal.open('#optional-prod-details-modal');
  }

  onCloseClick() {
    this.modal.close();
  }
}

export default FormOffer;



// WEBPACK FOOTER //
// ./src/btu/js/components/FormOffer.js